import { makeRouteConfig, Route } from 'found';
import React from 'react';
import { graphql } from 'react-relay';
import InvoiceQuery from './InvoiceQuery';
import AppContainer from '../components/App/AppContainer';
import RootComponent from '../components/RootComponent';
import SettingsContainer from '../components/App/SettingsContainer';
import FinancialContainer from '../components/Financial/FinancialContainer';
import InvoicesContainer from '../components/Financial/Invoices/InvoicesContainer';
import InvoiceListContainer from '../components/Financial/Invoices/InvoiceListContainer';
import InvoiceListLoader from '../components/Financial/Invoices/InvoiceListLoader';
import PaymentsGraphContainer from '../components/Financial/PaymentsGraph/PaymentsGraphContainer';
import PaymentsComponent from '../components/Financial/Payments/PaymentsComponent';
import CompletedPaymentsContainer from '../components/Financial/Payments/CompletedPaymentsContainer';
import OutstandingPaymentsContainer from '../components/Financial/Payments/OutstandingPaymentsContainer';
import RefundsContainer from '../components/Financial/Payments/RefundsContainer';
import { Loader } from '../components/Elements';
import LeadRoutes from './LeadRoutes';
import ShareRoutes from './ShareRoutes';
import DocumentRoutes from './DocumentRoutes';
import EventRoutes from './EventRoutes';
import TemplateRoutes from './TemplateRoutes';
import EventListRoute from './_EventListRoute';
import TemplateListRoute from './_TemplateListRoute';
import InvoiceListParams from './params/InvoiceListParams';
import PaymentsGraphParams from './params/PaymentsGraphParams';
import CompletedPaymentsParams from './params/CompletedPaymentsParams';
import CompletedPaymentsQuery from './CompletedPaymentsQuery';
import OutstandingPaymentsParams from './params/OutstandingPaymentsParams';
import OutstandingPaymentsQuery from './OutstandingPaymentsQuery';
import RefundsParams from './params/RefundsParams';
import RefundsQuery from './RefundsQuery';
import SearchRoute from './_SearchRoute';

export default makeRouteConfig(
  <Route Component={RootComponent}>
    <Route
      path='/'
      Component={AppContainer}
      query={graphql`
        query Route_App_Query {
          viewer {
            ...AppContainer_viewer
          }
        }
      `}
      render={({ props }) => (props ? <AppContainer {...props} /> : <Loader />)}
    >
      <Route
        path='settings'
        Component={SettingsContainer}
        query={graphql`
          query Route_Settings_Query {
            viewer {
              ...SettingsContainer_viewer
            }
          }
        `}
        render={({ props }) => (
          props ? <SettingsContainer {...props} /> : <Loader />
        )}
      />
      {SearchRoute}
      {EventListRoute}
      {EventRoutes}
      {LeadRoutes}
      {ShareRoutes}
      {TemplateListRoute}
      <Route
        Component={FinancialContainer}
        path='financials'
        query={graphql`
          query Route_Financials_Query {
            viewer {
              ...FinancialContainer_viewer
            }
          }
        `}
        render={({ props }) => (props ? <FinancialContainer {...props} /> : <Loader />)}
      >
        <Route
          Component={PaymentsGraphContainer}
          prepareVariables={PaymentsGraphParams}
          query={graphql`
            query Route_PaymentsGraph_Query(
              $completed_payments_before: ISO8601Type
              $completed_payments_after: ISO8601Type
              $outstanding_payments_before: ISO8601Type
              $outstanding_payments_after: ISO8601Type
              $refunds_before: ISO8601Type
              $refunds_after: ISO8601Type
            ) {
              viewer {
                ...PaymentsGraphContainer_viewer @arguments(
                  completed_payments_before: $completed_payments_before
                  completed_payments_after: $completed_payments_after
                  outstanding_payments_before: $outstanding_payments_before
                  outstanding_payments_after: $outstanding_payments_after
                  refunds_before: $refunds_before
                  refunds_after: $refunds_after
                )
              }
            }
          `}
          render={({ props }) => (props ? <PaymentsGraphContainer {...props} /> : <Loader />)}
        />
        <Route
          path='invoices'
          Component={InvoicesContainer}
          query={graphql`
            query Route_Invoice_Query {
              viewer {
                ...InvoicesContainer_viewer
              }
            }
          `}
          render={({ props }) => (props ? <InvoicesContainer {...props} /> : <Loader />)}
        >
          <Route
            prepareVariables={InvoiceListParams}
            Component={InvoiceListContainer}
            query={InvoiceQuery}
            render={({ props }) => (props ? <InvoiceListContainer {...props} /> : <InvoiceListLoader />)}
          />
        </Route>
        <Route
          path='payments'
          Component={PaymentsComponent}
        >
          <Route
            Component={CompletedPaymentsContainer}
            prepareVariables={CompletedPaymentsParams}
            query={CompletedPaymentsQuery}
            render={({ props }) => (props ? <CompletedPaymentsContainer {...props} /> : <Loader />)}
          />
          <Route
            path='outstanding'
            Component={OutstandingPaymentsContainer}
            prepareVariables={OutstandingPaymentsParams}
            query={OutstandingPaymentsQuery}
            render={({ props }) => (props ? <OutstandingPaymentsContainer {...props} /> : <Loader />)}
          />
          <Route
            path='refunds'
            Component={RefundsContainer}
            prepareVariables={RefundsParams}
            query={RefundsQuery}
            render={({ props }) => (props ? <RefundsContainer {...props} /> : <Loader />)}
          />
        </Route>
      </Route>
    </Route>
    {TemplateRoutes}
    {DocumentRoutes}
  </Route>
);



// WEBPACK FOOTER //
// ./webpack/routes/Route.js